module.exports = __webpack_public_path__ + "img/articleSoinDentaire.2f24d4e3.png";